import {isEmpty} from "@/utils/fileHelper";
import { formatDate } from "@/utils/communHelper";
import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../utils/auth";
let controle_dossier_mixin = {
  data () {
    return {
      allTraitements: [],
      isEmpty,
      formatDate,
    }
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + ' ' + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
    this.getAllTraitements();
  },
  methods: {
    getAllTraitements() {
      this.$axios
        .get("/administration/traitements")
        .then(response => {
          this.allTraitements = response.data.traitements;
        });
    },
    getLibelleTraitement(dossier, type, traitement_id) {
      let traitementId = '';
      if (traitement_id === null) {
        traitementId = this.getDossierTypeTraitement(dossier)
      } else {
        traitementId = traitement_id
      }
      // let traitementId = this.getDossierTypeTraitement(dossier);
      let traitement = this.allTraitements.reduce((res, treatment) => {
        return parseInt(treatment.id, 10) === traitementId ? treatment : res
      }, null);
      if (traitement) {
        return type === 'court' ? traitement.libelle_court : traitement.libelle;
      }
      return '';
    },
    getFontColor(dossier, traitementId) {
      let style = '';
      let traitement = this.allTraitements.reduce((res, traitement) => {
        return parseInt(traitement.id,10) === parseInt(traitementId,10) ? traitement : res;
      },{});
      style = traitement ? 'color: ' + traitement.font_color + ';' : '';

      return style;
    },
    getDossierTypeTraitement(dossier) {
      let traitementId = '';
      if (!isEmpty(dossier.traitement_id)) {
        traitementId = dossier.traitement_id;
      }
      else {
        const traitementGestionIj = this.allTraitements.reduce((res, traitement) => {
          return traitement.libelle_technique === 'ij_gestion_prestation' ? traitement : res;
        }, {});
        const traitementGestionInval = this.allTraitements.reduce((res, traitement) => {
          return traitement.libelle_technique === 'gestion_inval' ? traitement : res;
        }, {});
        const traitementGestionDc = this.allTraitements.reduce((res, traitement) => {
          return traitement.libelle_technique === 'gestion_dc' ? traitement : res;
        }, {});
        const traitementGestionDb = this.allTraitements.reduce((res, traitement) => {
          return traitement.libelle_technique === 'gestion_dbco' ? traitement : res;
        }, {});

        if (dossier.type && dossier.type.groupe.toLowerCase() === 'ij') {
          traitementId = traitementGestionIj.id;
        } else if (dossier.type && dossier.type.groupe.toLowerCase() === 'inval') {
          traitementId = traitementGestionInval.id;
        } else if (dossier.type && dossier.type.groupe.toLowerCase() === 'dc') {
          traitementId = traitementGestionDc.id;
        } else if (dossier.type && dossier.type.groupe.toLowerCase() === 'dbco') {
          traitementId = traitementGestionDb.id;
        }
      }

      return traitementId;
    },
    getIconSrc(type, dossier) {
      let images = require.context('@/assets/images/', false, /\.png$/)
      let icon = ''

      if (type === 'corner') {
        icon = 'corner-top-right-10.png'
      }

      if (type === 'post-it') {
        if (dossier.commentaires_gestion.length === 0) {
          icon = 'post-it-no-note-26.png'
        } else {
          let urgent = dossier.commentaires_gestion.reduce((res, item) => {
            return res || item.is_urgent
          }, false);
          if (dossier.commentaires_gestion[0].gestionnaire != null) {
            icon = urgent ? 'post-it-urgent-26.png' : 'post-it-normal-26.png';
          } else {
            icon = urgent ? 'post-it-urgent-vert-26.png' : 'post-it-vert-26.png';
          }
        }
      }
      return images('./' + icon)
    },
    getInfosSegmentProduit(dossier) {
      let produit = dossier.famille_produit ? dossier.famille_produit.libelle : 'n.d';
      return this.getSegmentGestion(dossier) + '<br><span style="color: #F96706;">' + produit + '</span>';
    },
    getSegmentGestion(dossier) {
      let response = 'n.d';
      if (dossier.siren) {
        if (dossier.siren.preference) {
          response = dossier.siren.preference.segment_gestion ? dossier.siren.preference.segment_gestion.libelle : 'n.d';
        }
      }
      return response;
    },
    formatNir(textNir) {
      if (textNir !== null && textNir !== '') {
        let displayNir = '';

        displayNir = textNir.substring(0, 1) + ' ' + textNir.substring(1, 3) + ' ' + textNir.substring(3, 5) + ' ' + textNir.substring(5, 7) + ' ' + textNir.substring(7, 10) + ' ' + textNir.substring(10, 13) + ' ' + textNir.substring(13, 15)
        return displayNir
      } else {
        return textNir
      }
    },
    getInfosStatus(dossier, traitementId) {
      return '<b>' + this.getStatus(dossier, 'parent', traitementId) + '</b><br>' + this.getStatus(dossier, 'sousStatut', traitementId);
    },
    getStatus(dossier, type, traitement_id) {
      let response = '';
      let traitementId = '';
      if (traitement_id === null) {
        traitementId = this.getDossierTypeTraitement(dossier);
      } else {
        traitementId = traitement_id
      }
      // let traitementId = this.getDossierTypeTraitement(dossier);
      for (let status of dossier.status) {
        if (parseInt(status.pivot.traitement_id, 10) === traitementId) {
          if (type === 'parent') {
            response = status.parent ? status.parent.libelle_bo : status.libelle_bo
          } else if (type === 'sousStatut') {
            response = status.parent ? status.libelle_bo : '-'
          }
        }
      }
      return response
    },
    displayWarningModal(message, title = 'Attention !') {
      this.$swal({
        position: 'top',
        type: 'warning',
        title: title,
        text: message,
        showConfirmButton: false,
        timer: 4000
      });
    },
    displayErrorModal(message, title = 'Attention !') {
      this.$swal({
        position: 'top',
        type: 'error',
        title: title,
        text: message,
        showConfirmButton: false,
        timer: 4000
      });
    },
  }
};

export default controle_dossier_mixin;

